import React, {useContext} from "react";
import "./Bootcamp.scss";
import { ReactComponent as LavoroAiIcon } from "../assets/images/nav-icons/lavoro-bowl.svg";
import { ReactComponent as AIAssistant }from "../assets/images/nav-icons/aiassistant.svg";
import { ReactComponent as StarIcon } from "../assets/images/nav-icons/star.svg";
import AppContext from "../config/AppContext";
import { useTranslation } from "react-i18next";

const Bootcamp = ({ setPredictionCount, setShowBootcamp, setShowSelectionAnimation }) => {
      const { mode } = useContext(AppContext);
      const { t } = useTranslation();
    const totalStars = 10;
    const activeStarIndex = 10;

      const handleBootcampClick = () => {
        localStorage.setItem('bootcampDismissed', 'true');
        setShowBootcamp(false);
        setPredictionCount(-1);
        setShowSelectionAnimation(false);
      };

    return (
        <div className="backdrop">
            <div className={mode === "dark" ? "BootcampPopupDark":"BootcampPopup"}>
                <div className="bootcamp">
                    <AIAssistant />
                    <span className={mode === "dark"? "bootcamptitleDark": "bootcamptitle"}>AI{t("RAL0981")}</span>
                </div>
                <div className="star-containerr">
                    {Array.from({ length: totalStars }).map((_, index) => {
                        const starIndex = index + 1; 
                        return (
                            <div
                                key={starIndex}
                                  className="star animated-star"
                                style={{ animationDelay: `${index * 0.2}s` }}
                            >
                                <StarIcon />
                            </div>
                        );
                    })}
                </div>

                <div className={mode === "dark" ? "completebootDark": "completeboot"}>
                    <span>
                        {activeStarIndex}{t("RAL0984")}
                    </span>
                </div>
                    <div className="bootcampbutton">
                        <button className={mode === "dark" ? "awesomebuttonDark" : "awesomebutton"}  
                        onClick={handleBootcampClick}
                        >{t("RAL0985")}</button>
                    </div>
            </div>
        </div>
    );
};

export default Bootcamp;
